export const project = 'trilogy'; // need this for when we dynamically import utils

const compositeTypeMapping = {
	certified: 'CPO',
	new: 'new',
	used: 'used'
};

export const getVCategoryForPageView = ({ window: win }) => {
	const [category] =
		win?.DDC?.dataLayer?.page?.pageInfo?.pageName
			?.toLowerCase?.()
			.match(/new|used|certified/) || [];
	return compositeTypeMapping[category];
};

export const getVehicleImpressions = ({ vehicles = [] }) =>
	vehicles.map((vehicle, index) => ({
		id: vehicle.vin,
		name: vehicle.model,
		price: vehicle.finalPrice || 0,
		brand: vehicle.make,
		category: vehicle.inventoryType,
		position: index + 1,
		list: 'vlp',
		dimension4: vehicle.modelYear,
		dimension5: vehicle.exteriorColor,
		dimension6: vehicle.fuelType,
		dimension7: null,
		variant: vehicle.trim,
		cm1: vehicle.startingPrice || 0
	}));
